import { createElementVNode, openBlock, createElementBlock } from "@histoire/vendors/vue";
import _export_sfc from "../../_virtual/plugin-vue_export-helper.js";
const _sfc_main = {};
const _hoisted_1 = { fill: "none" };
const _hoisted_2 = /* @__PURE__ */ createElementVNode("pattern", {
  id: "checkerboard",
  width: "64",
  height: "64",
  patternUnits: "userSpaceOnUse"
}, [
  /* @__PURE__ */ createElementVNode("rect", {
    x: "0",
    y: "0",
    width: "32",
    height: "32",
    fill: "currentColor"
  }),
  /* @__PURE__ */ createElementVNode("rect", {
    x: "32",
    y: "32",
    width: "32",
    height: "32",
    fill: "currentColor"
  })
], -1);
const _hoisted_3 = /* @__PURE__ */ createElementVNode("rect", {
  x: "0",
  y: "0",
  width: "100%",
  height: "100%",
  fill: "url(#checkerboard)"
}, null, -1);
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
];
function _sfc_render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _hoisted_4);
}
var CheckerboardPattern = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render]]);
export { CheckerboardPattern as default };
